import { createAsyncThunk } from '@reduxjs/toolkit';

import { namespace } from '@/modules/car/namespace';
import { ThunkResult } from '@/shared/actions/thunk-result';
import type { TFsmContext } from '@/shared/store/finite-state-machine/types';

import { resetCarForm, updateForm } from '../actions';

import { loadCarById } from './load-car-by-id';

let lastRequestId: string | undefined;

const prepareCarForm = createAsyncThunk(
  `${namespace}/prepare-car-form`,
  async (context: TFsmContext, { dispatch, requestId }): Promise<ThunkResult> => {
    lastRequestId = requestId;

    const car = await dispatch(loadCarById(context.carId)).unwrap();

    if (lastRequestId !== requestId) {
      return { isReplaced: true };
    }

    if (car) {
      dispatch(updateForm(car));
    } else {
      dispatch(resetCarForm());
    }

    return { isSucceed: true };
  },
);

export { prepareCarForm };
